<template>
		
	<dl class="opport-screen bdbe">
		<dt class="fl" v-if="curWebsite.type!=4 && curWebsite.type!=6 && curWebsite.type!=5">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</dt>
		<dt class="fl" v-if="curWebsite.type==4 || curWebsite.type==6">排行榜</dt>
		<dt class="fl" v-if="curWebsite.type==5">推荐类型</dt>
		<dd class="fl"> 
			<span :key="index" v-for="(item,index) in curNavlist" @click="freeClick(item)"  v-show="item.type!='b' || showmoreList" :class="tabCode == item.code ?'a-screen current':'a-screen'" >{{item.name}}</span>  
			<span class="a-screen" @click="showmoreList=!showmoreList" v-show="curWebsite.type!=4 && curWebsite.type!=6 && curWebsite.type!=5">{{showmoreList?'隐藏更多推荐':'更多线索推荐>>'}}</span> 
		</dd>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
	</dl>
</template> 
<script>
	export default {
		name: 'ClueNav',
		props:{
			searchtype:{
				type: Number,
				default: 0,
			},
			tabCode:{
				type:String,
				default:"yszs",
			}
		},
		data: function(){
			return{
				isShowFreeUserTips: false,
					iszsdn:this.$api.iszsdn(),xstext:"", 
					showmoreList:false,curWebsite:this.$api.getWebsiteType(),  
					//招商 研究(治理) 园区 信贷四个不同的header
					curNavlist:[],
					zsNavList:[
						{index:1,type:"a",code:"yszs",url:"/investment-clues2",name:"以商招商线索",},
						{index:2,type:"a",code:"zbzs",url:"/investment-clues3",name:"资本招商线索"},
						{index:3,type:"a",code:"qytzck",url:"/enterpriseInvestmentWindow",name:"企业投资窗口"},
						{index:4,type:"a",code:"cytzck",url:"/industryInvestmentWindow",name:"产业投资窗口"},
						{index:4,type:"a",code:"glqy",url:"/associated-enterprise-clues",name:"关联企业线索"},
						// {index:5,type:"b",code:"xzxm",url:"/siteProject",name:"选址项目线索"},
						{index:6,type:"b",code:"zdqyzs",url:"/investment-clues1",name:"重点区域招商线索"},
						{index:7,type:"b",code:"rdcyrdqy",url:"/investment-clues5",name:"热点产业的重点企业线索"},
						{index:8,type:"b",code:"zdcszdcy",url:"/investment-clues6",name:"重点城市的重点产业线索"},
						{index:9,type:"b",code:"zdcyzdcs",url:"/investment-clues7",name:"重点产业的重点城市线索"},
						{index:10,type:"b",code:"yzssgszs",url:"/investment-clues4",name:"优质上市公司招商线索"}, 
						{index:11,type:"b",code:"phb",url:"/investment-clues8",name:"排行榜线索"},
						{index:12,type:"b",code:"zdbd",url:"/investment-clues9",name:"重点榜单线索"},
					],
					zlNavlist:[
						{index:1,type:"a",code:"yszs",url:"/investment-clues2",name:"以商招商",},
						{index:2,type:"a",code:"zbzs",url:"/investment-clues3",name:"资本招商"},
						{index:3,type:"a",code:"qytzck",url:"/enterpriseInvestmentWindow",name:"企业投资窗口"},
						{index:4,type:"a",code:"cytzck",url:"/industryInvestmentWindow",name:"产业投资窗口"}, 
						{index:6,type:"b",code:"zdqyzs",url:"/investment-clues1",name:"重点区域招商"},
						{index:7,type:"b",code:"rdcyrdqy",url:"/investment-clues5",name:"热点产业的重点企业"},
						{index:8,type:"b",code:"zdcszdcy",url:"/investment-clues6",name:"重点城市的重点产业"},
						{index:9,type:"b",code:"zdcyzdcs",url:"/investment-clues7",name:"重点产业的重点城市"},
						{index:10,type:"b",code:"yzssgszs",url:"/investment-clues4",name:"优质上市公司招商"}, 
						{index:11,type:"b",code:"phb",url:"/investment-clues8",name:"排行榜"},
						{index:12,type:"b",code:"zdbd",url:"/investment-clues9",name:"重点榜单"},
					],
					//以商招商线索——产业链金融  资本招商线索——投贷联动融资线索  企业投资窗口——企业投资（融资）窗口期  产业投资窗口——产业投资（融资）窗口期  热点产业重点企业线索——风口产业的重点企业
						// 优质上市公司招商线索——优质上市公司筛选器  排行榜线索——企业投资排行榜 
					xdNavlist:[
						{index:1,type:"a",code:"yszs",url:"/investment-clues2",name:"产业链金融",},
						{index:2,type:"a",code:"zbzs",url:"/investment-clues3",name:"投贷联动融资线索"},
						{index:3,type:"a",code:"qytzck",url:"/enterpriseInvestmentWindow",name:"企业投资（融资）窗口期 "},
						{index:4,type:"a",code:"cytzck",url:"/industryInvestmentWindow",name:"产业投资（融资）窗口期 "},
						// {index:5,type:"b",code:"zdqyzs",url:"/investment-clues1",name:"重点区域招商"},
						{index:6,type:"a",code:"rdcyrdqy",url:"/investment-clues5",name:"风口产业的重点企业"},
						// {index:7,type:"b",code:"zdcszdcy",url:"/investment-clues6",name:"重点城市的重点产业"},
						// {index:8,type:"b",code:"zdcyzdcs",url:"/investment-clues7",name:"重点产业的重点城市"},
						{index:9,type:"a",code:"yzssgszs",url:"/investment-clues4",name:"优质上市公司筛选器"}, 
						{index:10,type:"a",code:"phb",url:"/investment-clues8",name:"企业投资排行榜"},
						// {index:11,type:"b",code:"zdbd",url:"/investment-clues9",name:"重点榜单"},
					],
					yjNavlist:[
						// {code:"C-ZDCYZDCS",switch:true,name:"",oldtext:"重点产业城市排行",url:"/investment-clues7"},
						// {code:"T-TZJG",switch:true,name:"",oldtext:"热点产业企业排行",url:"/investment-clues5"},
						// {code:"T-BGQYND",switch:true,name:"",oldtext:"重点城市产业排行",url:"/investment-clues6"},
						// {code:"T-LTQYND",switch:true,name:"",oldtext:"重点区域企业排行",url:"/investment-clues1"}, 
						// {code:"T-HYTZDT",switch:true,name:"",oldtext:"上市公司排行榜",url:"/investment-clues4"}, 
						// {code:"B-CYZC",switch:true,name:"",oldtext:"企业投资排行榜",url:"/investment-clues8"}, 
						{index:8,type:"a",code:"zdcyzdcs",url:"/investment-clues7",name:"重点产业城市排行"},
						{index:6,type:"a",code:"rdcyrdqy",url:"/investment-clues5",name:"热点产业企业排行"},
					 {index:7,type:"a",code:"zdcszdcy",url:"/investment-clues6",name:"重点城市产业排行"},
						{index:5,type:"a",code:"zdqyzs",url:"/investment-clues1",name:"重点区域企业排行"},
						{index:9,type:"a",code:"yzssgszs",url:"/investment-clues4",name:"上市公司排行榜"},
						{index:10,type:"a",code:"phb",url:"/investment-clues8",name:"企业投资排行榜"}, 
					],
					tzNavlist:[  
						{index:1,type:"a",code:"cytztj",url:"/recommendation",name:"产业投资推荐"},
						{index:5,type:"a",code:"zdqyzs",url:"/investment-clues1",name:"区域企业推荐"},
						{index:9,type:"a",code:"yqqytj",url:"/industrialpark",name:"园区企业推荐"},   
					],
					importantList:[
						
					],
					moreList:[
					
					],
					
		 
			};
		},
		created() {
			if(this.curWebsite.type == 1 || this.curWebsite.type == 7 || this.curWebsite.type == 8 || this.curWebsite.type == 9){
				this.xstext="线索";
				this.curNavlist=this.zsNavList;
			}else if(this.curWebsite.type== 2){
				this.curNavlist=this.zlNavlist;
			}else if(this.curWebsite.type == 4){
				this.curNavlist=this.xdNavlist;
			}else if(this.curWebsite.type == 6){
				this.curNavlist=this.yjNavlist;
			}else if(this.curWebsite.type == 5){
				this.curNavlist=this.tzNavlist;
			}
			var demonstrate=this.$api.demonstrate();
			if(demonstrate){
				this.curNavlist=this.curNavlist.filter(list=>{
					return list.code!='xzxm';
				})
			}
			
			
			
		},
		watch:{
			searchtype:{
				handler(newVal,oldVal){ 
					var allNavList=this.curNavlist;
					for(var i=0;i<allNavList.length;i++){
						if(this.tabCode == allNavList[i].code){  
							if(allNavList[i].type == 'b'){
								document.title=this.curWebsite.name+"-"+allNavList[i].name;
								this.showmoreList=true;
							}
						}
					} 
					this.type=newVal; 
				}
			}
			
			
		},
		mounted() {
		var allNavList=this.curNavlist;
		for(var i=0;i<allNavList.length;i++){
			if(this.tabCode == allNavList[i].code){  
				if(allNavList[i].type == 'b'){
					document.title=this.curWebsite.name+"-"+allNavList[i].name;
					this.showmoreList=true;
				}
			}
		} 
		},
		methods: {
			freeClick(item){
				// if(!this.userdata.token){
				// 		this.isShowFreeUserTips = true;
				// 		return;
				// 	} 
				this.routerself(item.url);
			}
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
</style>